import { persistStore } from "@/persist-store";

import type { DemoWelcomeState } from "./types";

const DEMO_WELCOME_STORAGE_KEY = "demo-welcome";

export type DemoWelcomeProfile = Pick<
  DemoWelcomeState,
  "email" | "name" | "role" | "industry" | "orgName" | "mode"
>;

interface DemoWelcomeStorage {
  completed: boolean;
  completedAt?: string;
  profile?: DemoWelcomeProfile;
}

export async function getDemoWelcomeStorage(): Promise<DemoWelcomeStorage | null> {
  return persistStore.getSession<DemoWelcomeStorage>(DEMO_WELCOME_STORAGE_KEY);
}

export async function isDemoWelcomeComplete(): Promise<boolean> {
  const data = await getDemoWelcomeStorage();
  return data?.completed === true;
}

export async function markDemoWelcomeComplete(
  profile: DemoWelcomeProfile,
): Promise<void> {
  await persistStore.putSession<DemoWelcomeStorage>(DEMO_WELCOME_STORAGE_KEY, {
    completed: true,
    completedAt: new Date().toISOString(),
    profile,
  });
}

export async function clearDemoWelcomeComplete(): Promise<void> {
  await persistStore.removeSession(DEMO_WELCOME_STORAGE_KEY);
}

/** Clears completion flag so the welcome flow can run again from step 1. */
export async function restartDemoOnboarding(): Promise<void> {
  await clearDemoWelcomeComplete();
}
